import React, { useContext, useEffect, useState } from 'react';
import { AppContext, DataList, LobbyBannerContext } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import { useStyletron } from 'baseui';
import { Select } from 'baseui/select';
import { ZUPEE_GAMES } from 'pages/dashboard/tournamentV2/utils/constants';
import { Button } from 'baseui/button';
import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { columnConfigs } from './listConfig';
import { LOBBY_BANNERS_ZK_VALUES } from '../../utils/constants';

const lobbyBannerList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { getLobbyBannersData } = useService();

	const [css] = useStyletron();
	const { app } = useContext(AppContext);

	const [gameName, setGameName] = useState(ZUPEE_GAMES[0]);
	const [refresh, setRefresh] = useState(false);
	const [forceUpdateLobbyBanner, setForceUpdateLobbyBanner] = useState(false);
	const handleChange = (option?: any) => {
		setGameName(option);
	};
	const onRefresh = () => {
		setRefresh(true);
	};

	const { setLobbyBannerData } = useContext(LobbyBannerContext);

	const fetchLobbyBanners = async () => {
		const result = await getLobbyBannersData({
			app,
			gameName: gameName.label,
			serviceName: LOBBY_BANNERS_ZK_VALUES.serviceName
		});
		setForceUpdateLobbyBanner(false);
		setRefresh(false);
		setLobbyBannerData({ ...result, gameName: gameName.label });
		return result;
	};
	useEffect(() => {
		setForceUpdateLobbyBanner(true);
	}, [gameName, refresh]);

	return (
		<>
			<div className={css({ display: 'flex', width: '50%', justifyContent: 'center', margin: 'auto' })}>
				<div
					className={css({
						width: '230px !important'
					})}>
					<Select
						options={ZUPEE_GAMES}
						overrides={{
							ControlContainer: {
								style: ({ $theme }) => ({
									backgroundColor: $theme.colors.contentInverseTertiary
								})
							}
						}}
						labelKey='label'
						valueKey='id'
						searchable={false}
						clearable={false}
						onChange={({ option }) => handleChange(option)}
						value={[gameName]}
					/>
				</div>
				<Button size='compact' onClick={onRefresh}>
					Refresh
				</Button>
			</div>
			<DataList
				fetchData={fetchLobbyBanners}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				rowHeight={100}
				entity={LIST_ENTITY_NAMES.LOBBY_BANNERS}
				initialSortDirection='ASC'
				initialSortIndex={1}
				globalForceUpdate={forceUpdateLobbyBanner}
			/>
		</>
	);
};

export default lobbyBannerList;
